import axios from 'services/axios';

const useAxiosPrivate = () => axios;

export default useAxiosPrivate;
